module.exports = __webpack_public_path__ + "static/media/box-fragile.1d902849.svg";